module.exports = __webpack_public_path__ + "img/selected7-min.a8a7c8cf.png";